const asyncParseJSON = string => new Response(string).json();
export default asyncParseJSON;
